import { Component, Input, SimpleChanges } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-performance-table',
  templateUrl: './performance-table.component.html',
  styleUrls: ['./performance-table.component.scss'],
})
export class PerformanceTableComponent {
  paginatedData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 1;
  elements: any;
  segmentOptions: any;
  length: any;
  isLoadingPage = false;
  @Input() isHovered = false;
  /** Page 1 only — the backend caches the client's whole fleet but only
   * ships page 1 here for a fast initial render. */
  @Input() data: any;
  /** True total across the client's whole fleet — drives the paginator. */
  @Input() totalRecords: any;

  constructor(
    private requestFormService: RequestFormService,
    private dashboardService: DashboardService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.currentPage = 1;
      this.applyPage(this.data);
    }
  }

  onPageChange(event: PageEvent) {
    const nextPage = event.pageIndex + 1;
    this.currentPage = nextPage;

    if (nextPage === 1) {
      // Already have page 1 from the initial data input — no need to refetch.
      this.applyPage(this.data);
      return;
    }

    this.isLoadingPage = true;
    const username = localStorage.getItem('username') ?? '';
    const subusername = localStorage.getItem('loginPic') ?? '';
    this.dashboardService.getFleetViewPage(username, nextPage, subusername).subscribe({
      next: (res: any) => {
        this.isLoadingPage = false;
        this.applyPage(res?.fleet_data ?? []);
      },
      error: (err) => {
        console.error('Failed to load fleet view page', err);
        this.isLoadingPage = false;
        this.paginatedData = [];
      },
    });
  }

  private applyPage(rows: any[]) {
    this.length = this.totalRecords ?? (rows || []).length;

    // Client scoping and the active-only filter already happened
    // server-side when the cache was built - no need to re-filter here.
    const offset = (this.currentPage - 1) * this.itemsPerPage;
    this.elements = (rows || []).map((item: any, index: number) => ({
      sNo: offset + index + 1,
      shipName: item.shipName
        ? String(item.shipName)
            .toLowerCase()
            .split(' ')
            .filter((word: string) => word)
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
        : '',
      imoNumber: item.vessel_id || '__',
      segment: item.segment,
      timeLost: item.timeLostGain.toFixed(1),
      fromDate: item.from,
      avg_speed_in_gw: item.avg_speed_in_gw.toFixed(2),
      bunkerLostOrGain: {
        HSFO: item.bunker.hsfo !== 0 ? item?.bunker?.hsfo.toFixed(2) : '__',
        VLSFO: item.bunker.vlsfo !== 0 ? item.bunker.vlsfo.toFixed(2) : '__',
        GO: item.bunker.go !== 0 ? item.bunker.go.toFixed(2) : '__',
      },
      // claimEst: {
      //   hire: item.claimEst.hire,
      //   bunkPrice: item.claimEst.bunkPrice,
      // },
      vessel_status: true,
    }));
    this.segmentOptions = Array.from(
      new Set(this.elements?.map((item: any) => item.segment) || []),
    );
    this.paginatedData = this.elements;
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
